import React, { useEffect, useState } from 'react';
import { DangerModal } from '../components/Shell/Modal';
import useModal from '../hooks/useModal';

const DeleteModal = () => {
	const { open, setOpen, setClose } = useModal('deleteModal');
	const [form, setForm] = useState({});

	useEffect(() => {
		if (open) {
			setForm(open?.defaultForm || {});
		}
	}, [open]);

	return (
		<DangerModal
			name="deleteModal"
			open={!!open}
			onClose={() => setClose()}
			title={open?.title}
			children={
				<>
					{typeof open?.description === 'function'
						? open?.description(form, setForm)
						: open?.description}
					{typeof open?.form === 'function' ? open?.form(form, setForm) : null}
				</>
			}
			confirmText={open?.confirmText}
			onConfirm={() => open?.onConfirm(form)}
		/>
	);
};

export default DeleteModal;
